import React from 'react';
import '../../../../oldPage/newpage/tools/GsdeBase.css'
import '../../../../oldPage/newpage/progress/progressBlock/ProgressBlock.css'

export function ProgressTitle(props: {
    children?: JSX.Element | Array<JSX.Element> | string,
}) {
    return (
        <div className="progress-block">
            <div className="progress-block-title-icon"/>
            <div className="progress-block-title-text">
                {props.children}
            </div>
        </div>
    )
}

export default function ProgressBlock(props: {
    title?: string,
    children?: JSX.Element | Array<JSX.Element> | string,
    className?: string
    contentsClassName?: string
    onWheel?: (event: React.WheelEvent) => void | undefined
}) {
    return (
                <div className={props.className} style={{height: 520}}>
                    <ProgressTitle>{props.title}</ProgressTitle>
                    <div style={{height: 500}}
                        className={"progress-block-contents " + props.contentsClassName}
                        onWheel={props.onWheel}
                    >
                        {props.children}
            </div>
        </div>
    )
}